<template>
    <section class="about-section">
        <div class="section-layout">
            <div class="copy-block">
                <div class="section-copy" v-html="aboutList.content"></div>
            </div>

            <div class="metrics-grid">
                <article class="metric-card">
                    <Trophy class="metric-icon" />
                    <h3>{{ aboutList.coach }}</h3>
                    <p>Elite coaches and staff dedicated to your success</p>
                </article>

                <article class="metric-card">
                    <Users class="metric-icon" />
                    <h3>{{ aboutList.members }}</h3>
                    <p>Members across the globe</p>
                </article>

                <article class="metric-card">
                    <Star class="metric-icon" />
                    <h3>{{ aboutList.excellence }}</h3>
                    <p>The LLTC 1895 standard</p>
                </article>

                <article class="metric-card">
                    <CalendarDays class="metric-icon" />
                    <h3>{{ aboutList.alumni }}</h3>
                    <p>Tennis stalwarts we trust</p>
                </article>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Trophy, Users, Star, CalendarDays } from 'lucide-vue-next';
import { ref, onMounted } from "vue";
import axios from 'axios';

const aboutList = ref({});

onMounted(async () => {
  await listRecords();
});

const listRecords = async () => {
  try {
    const response = await axios.get('/about_list.php');
    aboutList.value = response.data.status ? response.data.data[0] : {};
  } catch (error) {
    console.error(error.message);
  }
};
</script>

<style scoped lang="scss">
.about-section {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
}

.section-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
    gap: 32px;
    align-items: start;
}

.copy-block h2 {
    margin: 0;
    font-size: clamp(28px, 3vw, 44px);
    line-height: 1.1;
    font-weight: 700;
    color: #0f172a;
}

.section-kicker {
    margin: 0 0 10px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-copy {
    margin-top: 16px;
    color: #334155;
    font-size: 16px;
    line-height: 1.8;
    text-align: left;
}

.metrics-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
}

.metric-card {
    min-height: 220px;
    padding: 24px;
    border: 1px solid #e3e8ee;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbf9 100%);
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.metric-icon {
    color: #0f5b2b;
    width: 30px;
    height: 30px;
}

.metric-card h3 {
    margin: 12px 0 8px;
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
}

.metric-card p {
    margin: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.6;
}

@media (max-width: 992px) {
    .section-layout {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .metrics-grid {
        grid-template-columns: 1fr;
    }
}
</style>
